import { Injectable } from "@angular/core";
import { DataService } from "@app/core";
import {
  AccountDashboardSummaryDto,
  AccountDashboardSummaryPostDto,
  ActivityByPeriod,
  ActivityByPeriodGetDto,
  ActivityByPeriodPostDto,
  AdminDashboardSummaryDto,
  AdminDashboardSummaryPostDto,
  AppsActivityByPeriod,
  CustomLinksByPeriod,
  CustomLinksByPeriodPostDto,
  DashboardDataAvailabilityDto,
  EngagementOutcomeByPeriod,
  EngagementOutcomeByPeriodPostDto,
  KPIsByPeriod,
  KPIsByPeriodPostDto,
  SalesPersonActivityByPeriod,
  TopAccountActivityReportItemDto,
  TopAccountsActivityReportDto,
  TopLocationActivitiesByTemplateReportRequestDto,
  TopLocationActivitiesByTemplateReportItemDto,
  TopPartnersActivityReportItemDto,
  TopTerminalActivitiesReportItemDto,
  TopTerminalActivitiesReportRequestDto,
  TotalTransactionsByPeriodPostDto,
  TotalTransactionsByPeriodReport,
  TotalTransactionsReportByPeriodGetDto
} from "@app/models";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ReportingService {
  private serviceUrl = "Reporting";

  constructor(private http: DataService) {}

  getDashboardDataAvailability(): Observable<DashboardDataAvailabilityDto> {
    return this.http.get(`${this.serviceUrl}/dashboard/hasData`);
  }

  getAdminDashboardSummary(data: AdminDashboardSummaryPostDto): Observable<AdminDashboardSummaryDto> {
    return this.http.post(`${this.serviceUrl}/dashboard/summary/admin`, data);
  }

  getAccountDashboardSummary(data: AccountDashboardSummaryPostDto): Observable<AccountDashboardSummaryDto> {
    return this.http.post(`${this.serviceUrl}/dashboard/summary`, data);
  }

  getTotalActivitiesByPeriod(data: ActivityByPeriodPostDto): Observable<ActivityByPeriodGetDto<ActivityByPeriod>> {
    return this.http.post(`${this.serviceUrl}/totalActivitiesByPeriod`, data);
  }

  getLocationsActivitiesByPeriod(data: ActivityByPeriodPostDto): Observable<ActivityByPeriodGetDto<ActivityByPeriod>> {
    return this.http.post(`${this.serviceUrl}/locationsActivitiesByPeriod`, data);
  }

  getSalePersonsActivitiesByPeriod(data: ActivityByPeriodPostDto): Observable<ActivityByPeriodGetDto<SalesPersonActivityByPeriod>> {
    return this.http.post(`${this.serviceUrl}/salePersonsActivitiesByPeriod`, data);
  }

  getAppsActivitiesByPeriod(data: ActivityByPeriodPostDto): Observable<ActivityByPeriodGetDto<AppsActivityByPeriod>> {
    return this.http.post(`${this.serviceUrl}/appsActivitiesByPeriod`, data);
  }

  getTotalKPIsByPeriod(data: KPIsByPeriodPostDto): Observable<ActivityByPeriodGetDto<KPIsByPeriod>> {
    return this.http.post(`${this.serviceUrl}/kpiActivitiesByPeriod`, data);
  }

  getTotalEngagementOutcomesByPeriod(
    data: EngagementOutcomeByPeriodPostDto
  ): Observable<ActivityByPeriodGetDto<EngagementOutcomeByPeriod>> {
    return this.http.post(`${this.serviceUrl}/totalEngagementsByPeriod`, data);
  }

  getTotalTransactionActivityByPeriod(
    data: TotalTransactionsByPeriodPostDto
  ): Observable<TotalTransactionsReportByPeriodGetDto<TotalTransactionsByPeriodReport>> {
    return this.http.post(`${this.serviceUrl}/totalTransactionActivitiesByPeriod`, data);
  }

  getTotalCustomLinksActivityByPeriod(data: CustomLinksByPeriodPostDto): Observable<ActivityByPeriodGetDto<CustomLinksByPeriod>> {
    return this.http.post(`${this.serviceUrl}/customLinksByPeriod`, data);
  }

  getAccountsActivityReport(data: TopAccountsActivityReportDto): Observable<TopAccountActivityReportItemDto[]> {
    return this.http.post(`${this.serviceUrl}/topAccountsActivityReport`, data);
  }

  getPartnersActivityReport(data: TopAccountsActivityReportDto): Observable<TopPartnersActivityReportItemDto[]> {
    return this.http.post(`${this.serviceUrl}/topPartnersActivityReport`, data);
  }

  getLocationsActivityReport(
    data: TopLocationActivitiesByTemplateReportRequestDto
  ): Observable<TopLocationActivitiesByTemplateReportItemDto[]> {
    return this.http.post(`${this.serviceUrl}/topLocationActivitiesByTemplate`, data);
  }

  getTerminalsActivityReport(data: TopTerminalActivitiesReportRequestDto): Observable<TopTerminalActivitiesReportItemDto[]> {
    return this.http.post(`${this.serviceUrl}/topTerminalActivities`, data);
  }
}
